import { ICellRendererParams } from "@ag-grid-community/core";
import React, { useRef } from "react";
import { useEventListener } from "usehooks-ts";

export interface MaybernTableFocusCellRendererWrapperProps {
  params: Pick<ICellRendererParams, "eGridCell">;
  inputRef: React.RefObject<{
    focus: () => void;
  }>;
}

export const MaybernTableFocusCellRendererWrapper: React.FC<
  React.PropsWithChildren<MaybernTableFocusCellRendererWrapperProps>
> = ({ children, params, inputRef }) => {
  useEventListener(
    "focusin",
    (event) => {
      if (event.target === params.eGridCell) {
        inputRef.current?.focus();
      }
    },
    useRef(params.eGridCell),
  );
  return children;
};
